import './Jyotish.scss';
import StarsOutlinedIcon from '@mui/icons-material/StarsOutlined';                  // Kundali
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined'; // Matchmaking
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';      // Janma Kundli
import NaturePeopleOutlinedIcon from '@mui/icons-material/NaturePeopleOutlined';    // Pancha Pakshi
import WbTwilightOutlinedIcon from '@mui/icons-material/WbTwilightOutlined';        // Rashifal
import NightlightOutlinedIcon from '@mui/icons-material/NightlightOutlined';        // Moonsign
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';      // Birthstar
import WhatshotOutlinedIcon from '@mui/icons-material/WhatshotOutlined';            // Mangal Dasha
import OpacityOutlinedIcon from '@mui/icons-material/OpacityOutlined';              // Kalsarpa Yoga
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined';          // Baby Name Finder
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';        // Name Initials
import LooksOneOutlinedIcon from '@mui/icons-material/LooksOneOutlined';            // Janma Lagna
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';              // Sunsign
import HistoryEduOutlinedIcon from '@mui/icons-material/HistoryEduOutlined';        // Sraddha Calculator
import Brightness2OutlinedIcon from '@mui/icons-material/Brightness2Outlined';      // Sahasra Chandradaya

import { Link } from 'react-router-dom';

const Jyotish = ({ onClose }) => {
  return (
    <div className="Jyotish-modal-overlay" onClick={onClose}>
      <div className="Jyotish-modal-content" onClick={e => e.stopPropagation()}>
        <div className="jyotish-container">
          <h2>Jyotish</h2>
          <div className="jyotish-grid">

            <Link to="/jyotish/kundali" className="jyotish-item">
              <StarsOutlinedIcon className="icon" />
              <h4>Kundali</h4>
            </Link>

            <Link to="/jyotish/matchmaking" className="jyotish-item">
              <FavoriteBorderOutlinedIcon className="icon" />
              <h4>Matchmaking</h4>
            </Link>

            <Link to="/jyotish/janma-kundali" className="jyotish-item">
              <AutoFixHighOutlinedIcon className="icon" />
              <h4>Janma Kundli</h4>
            </Link>

            <Link to="/jyotish/pancha-paki" className="jyotish-item">
              <NaturePeopleOutlinedIcon className="icon" />
              <h4>Pancha Pakshi Calculator</h4>
            </Link>

            {/* <Link to="/jyotish/rashifal" className="jyotish-item">
              <WbTwilightOutlinedIcon className="icon" />
              <h4>Rashifal</h4>
            </Link> */}

            <Link to="/jyotish/moonsign" className="jyotish-item">
              <NightlightOutlinedIcon className="icon" />
              <h4>Moonsign</h4>
            </Link>

            <Link to="/jyotish/birthstar" className="jyotish-item">
              <StarOutlineOutlinedIcon className="icon" />
              <h4>Birthstar</h4>
            </Link>

            <Link to="/jyotish/mangal-dasha" className="jyotish-item">
              <WhatshotOutlinedIcon className="icon" />
              <h4>Mongal Dasha</h4>
            </Link>

            <Link to="/jyotish/kalsarpa-yoga" className="jyotish-item">
              <OpacityOutlinedIcon className="icon" />
              <h4>Kalsarpa Yoga</h4>
            </Link>

            <Link to="/jyotish/baby-name-finder" className="jyotish-item">
              <ChildCareOutlinedIcon className="icon" />
              <h4>Baby Name Finder</h4>
            </Link>

            <Link to="/jyotish/name-initials" className="jyotish-item">
              <TextFieldsOutlinedIcon className="icon" />
              <h4>Name Initials</h4>
            </Link>

            <Link to="/jyotish/janma-lagna" className="jyotish-item">
              <LooksOneOutlinedIcon className="icon" />
              <h4>Janma Lagna</h4>
            </Link>

            <Link to="/jyotish/sunsign" className="jyotish-item">
              <WbSunnyOutlinedIcon className="icon" />
              <h4>Sunsign</h4>
            </Link>

            <Link to="/jyotish/sraddha-calculator" className="jyotish-item">
              <HistoryEduOutlinedIcon className="icon" />
              <h4>Sraddha Calculator</h4>
            </Link>

            <Link to="/jyotish/sahasra-chandradaya" className="jyotish-item">
              <Brightness2OutlinedIcon className="icon" />
              <h4>Sahasra Chandradaya</h4>
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Jyotish;
